import { TOGGLE_LINK_COMMAND } from '@lexical/link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Button, Divider } from '@mui/material';
import { LexicalEditor } from 'lexical';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { sanitizeUrl } from '../../../../../utils/url';
import StyledBox from './styles';

interface FloatingLinkViewProps {
  editor: LexicalEditor;
  startEditing: () => void;
  url: string;
  close: () => void;
}

export default function FloatingLinkView(props: FloatingLinkViewProps) {
  const {
    editor, startEditing, url, close,
  } = props;
  const { t } = useTranslation('wysiwyg');

  React.useEffect(() => {
    function listener(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
      }
    }
    window.addEventListener('keydown', listener);
    return () => { window.removeEventListener('keydown', listener); };
  }, []);

  return (
    <StyledBox>
      <Button
        className="cta"
        title={t('editor.link.edit')}
        onClick={() => {
          startEditing();
        }}
      >
        {t('editor.link.edit')}
      </Button>
      <Divider orientation="vertical" flexItem variant="middle" />
      <Button component="a" href={sanitizeUrl(url)} target="_blank" rel="noreferrer" title={t('editor.link.open')}>
        <OpenInNewIcon className="icon" />
      </Button>
      <Divider orientation="vertical" flexItem variant="middle" />
      <Button
        className="tools"
        title={t('editor.link.unlink')}
        onClick={() => {
          editor.dispatchCommand(TOGGLE_LINK_COMMAND, null);
        }}
      >
        <LinkOffIcon />
      </Button>
    </StyledBox>
  );
}
